import type { IProcess } from '../components/interfaces/process';
import { RequestStatus } from '../../common/enums/requestStatus';

export function isActiveProcess(process: IProcess, processes: IProcess[]): boolean {
    if (
        process.status !== RequestStatus.completed &&
        process.status !== RequestStatus.cancelled &&
        process.status !== RequestStatus.aborted
    ) {
        return true;
    } else {
        const followingRequest = processes.find((p) => p.previousRequestId === process.id);
        if (followingRequest) {
            return isActiveProcess(followingRequest, processes);
        } else {
            return false;
        }
    }
}
